import React from 'react';

// Define color mapping for Value for better visual cues (adjust colors as needed)
const valueColorMap = {
    'High': 'text-success',    // Green for High
    'Medium': 'text-warning',  // Yellow/Orange for Medium
    'Low': 'text-error',       // Red for Low
    'Unknown': 'text-base-content/50' // Default for unknown/missing
};

const sentimentColorMap = {
  'Positive': 'text-success',
  'Negative': 'text-error',
  'Meutral': 'text-info', // Using info color for neutral
  'Unknown': 'text-base-content/50'
};

const Snippet = ({ snippet, onClick }) => {
    // Guard clause in case snippet is somehow null or undefined
    if (!snippet) {
        return null;
    }

    // Safely access potentially nested data using optional chaining (?.)
    const snippetText = snippet.snippet || ''; // Fallback to empty string
    const snippetValue = snippet.value?.trim();   // e.g., 'High', 'Medium', 'Low'
    const sourceName = snippet.video?.source?.name?.trim(); // Get source name safely
    const snippetSentiment = snippet.sentiment?.trim();
    

    // Determine the color class for the value, default to gray if not found
    const valueColorClass = snippetValue ? (valueColorMap[snippetValue] || valueColorMap['Unknown']) : valueColorMap['Unknown'];
    const sentimentColorClass = snippetSentiment ? (sentimentColorMap[snippetSentiment] || sentimentColorMap['Unknown']) : sentimentColorMap['Unknown'];

    return (
        // Use group for hover state propagation
        <div className="mb-1 group"> {/* Reduced bottom margin slightly */}
            {/* Clickable area */}
            <div
                // Use theme colors for background on hover, adjust padding
                className="text-base-content/90 cursor-pointer transition-all duration-200 rounded-lg group-hover:bg-base-300/50 p-2 group-hover:p-3"
                onClick={() => onClick(snippet)} // Call the passed onClick handler
            >
                {/* Snippet Text */}
                {/* Apply hover effect only to the snippet text itself */}
                <span className="transition-all group-hover:font-medium"> {/* Make slightly bolder on hover */}
                    {snippetText}
                </span>

                {/* Metadata Section - Only render if value or source exists */}
                {(snippetValue || sourceName) && (
                    // Add margin-top, padding-top, and a subtle border
                    <div className="mt-2 pt-1.5 border-t border-base-content/10">
                        <span className="text-xs text-base-content/70 font-normal flex flex-wrap gap-x-2 items-center"> {/* Use flex-wrap for small screens */}
                            {/* Display Value with color */}
                            {snippetValue && (
                                <span className={`font-medium ${valueColorClass}`}>
                                    {snippetValue} Value
                                </span>
                            )}
                            {/* Separator shown only if both exist */}
                            {snippetValue && snippetSentiment && (
                                <span className="text-base-content/40">|</span>
                            )}
                             {snippetValue && (
                                <span className={`font-medium ${sentimentColorClass}`}>
                                    {snippetSentiment} 
                                </span>
                            )}
                            {/* Separator shown only if both exist */}
                            {snippetSentiment && sourceName && (
                                <span className="text-base-content/40">|</span>
                            )}
                            {/* Display Source Name */}
                            {sourceName && (
                                <span className="italic">
                                    {sourceName}
                                </span>
                            )}
                        </span>
                    </div>
                )}
            </div>
        </div>
    );
};

export default Snippet;